import { GridCellParams } from '@mui/x-data-grid';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mayaCustomerInitiativeEditRoute } from 'basics/constants/routes.constants';
import { CustomerInitiative, DashboardFilter } from 'generated/maya.types';
import { PAGINATION_PAGE_SIZE } from 'modules/maya/basics/constants/common.constant';
import useCiListConfig from 'modules/maya/components/Dashboard/CiDashboardGridlist/CiDashboardList.config';
import useGetDashboardCIQuery from 'modules/maya/graphql/queries/getDashboardCI';

const useCiDashboardList = (filters?: DashboardFilter) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGINATION_PAGE_SIZE);
  const [rowCountState, setRowCountState] = useState(0);
  const [cis, setCis] = useState<CustomerInitiative[]>([]);
  const navigate = useNavigate();

  const queryOptions = useMemo(
    () => ({
      limit: pageSize,
      offset: page * pageSize,
    }),
    [page, pageSize],
  );

  const { getDashboardCIQuery, ciCount, ciData, loading } = useGetDashboardCIQuery();

  useMemo(() => {
    if (filters) {
      getDashboardCIQuery({ variables: { filters, queryOptions } });
    }
  }, [filters, getDashboardCIQuery, queryOptions]);

  useEffect(() => {
    if (!loading && filters) {
      setCis(ciData);
    }
  }, [ciData, filters, loading]);

  useEffect(() => {
    setRowCountState((prevRowCountState) => (ciCount !== undefined ? ciCount as number : prevRowCountState));
  }, [ciCount, setRowCountState]);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const onPageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
  };

  const { customerInitiativeListColumnConfig } = useCiListConfig();

  const onCellClick = (params: GridCellParams) => {
    navigate(`${mayaCustomerInitiativeEditRoute}?id=${params.row._id}`);
  };

  return {
    customerInitiativeListColumnConfig,
    cis,
    loading,
    onPageChange,
    onPageSizeChange,
    rowCountState,
    onCellClick,
  };
};

export default useCiDashboardList;
